import { render, staticRenderFns } from "./OrderHistroyReceipt.html?vue&type=template&id=4de0b018&scoped=true&"
import script from "./OrderHistroyReceipt.ts?vue&type=script&lang=ts&"
export * from "./OrderHistroyReceipt.ts?vue&type=script&lang=ts&"
import style0 from "./OrderHistroyReceipt.css?vue&type=style&index=0&id=4de0b018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de0b018",
  null
  
)

export default component.exports